export default "__VITE_ASSET__D9ILulH4__"